export default "__VITE_ASSET__B2izZ7OT__"